import { createReducer, on } from '@ngrx/store';
import { InRoomCredentialsApiActions } from './in-room-credentials.actions';
import { initialState, adapter, selectIdFromCredentials } from './in-room-credentials.state';

export const inRoomCredentialsReducer = createReducer(
  initialState,
  on(InRoomCredentialsApiActions.credentialsLoaded, (state, { settings }) => adapter.upsertMany(settings, state)),
  on(InRoomCredentialsApiActions.credentialsAdded, (state, { setting }) => adapter.upsertOne(setting, state)),
  on(InRoomCredentialsApiActions.credentialsUpdated, (state, { setting }) =>
    adapter.updateOne(
      {
        id: selectIdFromCredentials(setting),
        changes: setting,
      },
      state
    )
  ),
  on(InRoomCredentialsApiActions.credentialsDeleted, (state, { setting }) =>
    adapter.removeOne(selectIdFromCredentials(setting), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectInRoomCredentialsIds = selectIds;
export const selectInRoomCredentialsEntities = selectEntities;
export const selectAllInRoomCredentials = selectAll;
